import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/user.slice"
import usersSlice from "./slices/users.slice";
import accountsSlice from "./slices/accounts.slice";
import rolesSlice from "./slices/roles.slice";


export const store = configureStore({
  reducer: {
    user:userReducer,
    users:usersSlice,
    accounts:accountsSlice,
    roles:rolesSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
